/* MEADOW GIFT - product page behaviour.
   Loaded only on product pages; cart, discounts, Klaviyo, and shared storefront
   interactions remain in mg-theme.js. */
(function () {
  'use strict';

  if (window.MG_PRODUCT_UI_READY) return;
  window.MG_PRODUCT_UI_READY = true;

  window.MG = window.MG || {};
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(selector, root) { return (root || document).querySelector(selector); }
  function $$(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function money(cents) {
    return window.MG.money ? window.MG.money(cents) : String(cents);
  }
  function paintPromoPrices(scope) {
    if (window.MG.paintPromoPrices) window.MG.paintPromoPrices(scope);
  }

  /* ---- pdp gallery ---- */
  function showMedia(gal, idx) {
    if (!gal) return;
    var thumbs = $$('[data-mg-thumb]', gal);
    var mediaCount = thumbs.length || $$('.mg-gal__slide', gal).length;
    if (!mediaCount) return;
    idx = (idx + mediaCount) % mediaCount;
    var main = $('[data-mg-main]', gal);
    var src = thumbs[idx] && thumbs[idx].getAttribute('data-full');
    if (main && src) { main.src = src; main.alt = thumbs[idx].getAttribute('data-alt') || ''; }
    thumbs.forEach(function (t, i) { t.setAttribute('aria-current', String(i === idx)); });
    $$('[data-mg-dot]', gal).forEach(function (d, i) { d.setAttribute('data-on', String(i === idx)); });
    var current = $('[data-mg-gallery-current]', gal);
    if (current) current.textContent = String(idx + 1);
    gal.setAttribute('data-index', String(idx));
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mg-thumb]');
    if (t) {
      e.preventDefault();
      var gal = t.closest('[data-mg-gallery]');
      showMedia(gal, $$('[data-mg-thumb]', gal).indexOf(t));
      return;
    }
    var arrow = e.target.closest('[data-mg-gal-step]');
    if (arrow) {
      e.preventDefault();
      var g = arrow.closest('[data-mg-gallery]');
      showMedia(g, parseInt(g.getAttribute('data-index') || '0', 10) + parseInt(arrow.getAttribute('data-mg-gal-step'), 10));
      return;
    }
  });

  /* ---- variant selection ---- */
  function paintColorCollapse(row) {
    var limit = parseInt(row.getAttribute('data-mg-color-limit'), 10);
    if (!limit || limit < 1) return;
    var buttons = $$('[data-mg-option]', row);
    var fieldset = row.closest('.mg-opt');
    var toggle = fieldset && $('[data-mg-color-toggle]', fieldset);
    if (!toggle || buttons.length <= limit) {
      if (toggle) toggle.hidden = true;
      buttons.forEach(function (button) { button.hidden = false; });
      return;
    }

    var expanded = row.getAttribute('data-mg-color-expanded') === 'true';
    var hiddenCount = 0;
    buttons.forEach(function (button, index) {
      var selected = button.getAttribute('aria-pressed') === 'true';
      var hide = !expanded && index >= limit && !selected;
      button.hidden = hide;
      if (hide) hiddenCount += 1;
    });
    toggle.hidden = false;
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.textContent = expanded ? 'Show fewer colors' : '+ ' + hiddenCount + ' more color' + (hiddenCount === 1 ? '' : 's');
  }

  function sortSwatches(scope) {
    $$('[data-mg-swatch-priority], [data-mg-color-limit]', scope || document).forEach(function (row) {
      if (row.getAttribute('data-mg-swatch-sorted') !== 'true') {
        var priorities = String(row.getAttribute('data-mg-swatch-priority') || '')
          .split(',').map(function (value) { return value.trim().toLowerCase(); }).filter(Boolean);
        if (priorities.length) {
          var buttons = $$('[data-mg-option]', row).map(function (button, index) {
            var value = String(button.getAttribute('data-value') || '').trim().toLowerCase();
            var priority = priorities.indexOf(value);
            return { button: button, order: priority < 0 ? priorities.length + index : priority, original: index };
          });
          buttons.sort(function (a, b) { return a.order - b.order || a.original - b.original; });
          buttons.forEach(function (item) { row.appendChild(item.button); });
        }
        row.setAttribute('data-mg-swatch-sorted', 'true');
      }
      paintColorCollapse(row);
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-mg-color-toggle]');
    if (!toggle) return;
    e.preventDefault();
    var fieldset = toggle.closest('.mg-opt');
    var row = fieldset && $('[data-mg-color-limit]', fieldset);
    if (!row) return;
    row.setAttribute('data-mg-color-expanded', row.getAttribute('data-mg-color-expanded') === 'true' ? 'false' : 'true');
    paintColorCollapse(row);
  });

  function updateVariantUrl(variantId) {
    if (!variantId || !window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', String(variantId));
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } catch (err) {}
  }

  function variantMatches(variant, chosen, exceptName) {
    for (var name in chosen) {
      if (name === exceptName) continue;
      if (!variant.options || variant.options[name] !== chosen[name]) return false;
    }
    return true;
  }

  function updateOptionAvailability(form, data, chosen) {
    $$('[data-mg-optgroup]', form).forEach(function (group) {
      var name = group.getAttribute('data-mg-optgroup');
      $$('[data-mg-option]', group).forEach(function (button) {
        var value = button.getAttribute('data-value');
        var available = data.some(function (variant) {
          return variant.available && variant.options && variant.options[name] === value && variantMatches(variant, chosen, name);
        });
        button.disabled = !available;
        button.setAttribute('aria-disabled', String(!available));
        var label = String(button.getAttribute('aria-label') || value || '').replace(/ — unavailable$/, '');
        if (button.classList.contains('mg-opt-color')) button.setAttribute('aria-label', label + (available ? '' : ' — unavailable'));
      });
    });
  }

  function updateSavings(form, price, compare) {
    var save = $('[data-mg-save]', form);
    if (!save) return;
    if (compare > price) {
      save.textContent = 'Save ' + Math.round((compare - price) * 100 / compare) + '%';
      save.hidden = false;
    } else {
      save.hidden = true;
    }
  }

  function updateStickyProduct(variant, options) {
    options = options || {};
    var variantText = $('[data-mg-sticky-variant]');
    var button = $('[data-mg-sticky-add]');
    var label = $('[data-mg-sticky-label]');
    var image = $('[data-mg-sticky-image]');
    var price = $('[data-mg-sticky-price]');
    var compare = $('[data-mg-sticky-compare]');
    var promo = $('[data-mg-sticky-promo]');
    var base = options.price != null ? Number(options.price || 0) : (variant ? Number(variant.price || 0) : 0);
    var compareValue = variant ? Number(variant.compare || 0) : 0;
    var available = variant ? Boolean(variant.available) : true;

    if (variantText) variantText.textContent = options.variantText || (variant && variant.title) || 'Select a size';
    if (image && variant && variant.image) image.src = variant.image;
    if (price && base) price.textContent = (options.varies ? 'From ' : '') + money(base);
    if (compare) {
      if (!options.varies && compareValue > base) { compare.textContent = money(compareValue); compare.hidden = false; }
      else compare.hidden = true;
    }
    if (promo && base) {
      promo.setAttribute('data-mg-promo-base', String(base));
      promo.setAttribute('data-mg-promo-compare', String(compareValue));
      promo.setAttribute('data-mg-promo-varies', String(Boolean(options.varies)));
      paintPromoPrices(promo);
    }
    if (button) {
      if (variant) button.setAttribute('data-product-id', String(variant.id));
      button.disabled = variant ? !available : false;
      button.setAttribute('aria-disabled', String(variant ? !available : false));
    }
    if (label) {
      label.textContent = options.incomplete
        ? 'CHOOSE SIZE'
        : (available ? (label.getAttribute('data-prefix') || 'ADD TO BAG') : 'SOLD OUT');
    }
  }

  function pickVariant(form) {
    if (!form) return;
    var data;
    try { data = JSON.parse(form.getAttribute('data-variants') || '[]'); } catch (err) { return; }
    var chosen = {};
    var complete = true;
    $$('[data-mg-optgroup]', form).forEach(function (g) {
      var on = g.querySelector('[data-mg-option][aria-pressed="true"]');
      if (on) chosen[on.getAttribute('data-mg-option')] = on.getAttribute('data-value');
      else complete = false;
    });
    updateOptionAvailability(form, data, chosen);
    if (!complete) {
      var candidates = data.filter(function (variant) { return variantMatches(variant, chosen); });
      var availableCandidates = candidates.filter(function (variant) { return variant.available; });
      var pool = availableCandidates.length ? availableCandidates : candidates;
      var representative = pool.reduce(function (best, variant) { return !best || variant.price < best.price ? variant : best; }, null) || data[0] || null;
      var lowest = pool.reduce(function (value, variant) {
        return value === null || variant.price < value ? variant.price : value;
      }, null);
      var priceText = lowest === null ? 0 : lowest;
      $$('[data-mg-price]', form).forEach(function (el) { if (priceText) el.textContent = 'From ' + money(priceText); });
      $$('[data-mg-compare]', form).forEach(function (el) { el.hidden = true; });
      updateSavings(form, priceText, 0);
      var promoIncomplete = form.querySelector('[data-mg-promo-price]');
      if (promoIncomplete && priceText) {
        promoIncomplete.setAttribute('data-mg-promo-base', String(priceText));
        promoIncomplete.setAttribute('data-mg-promo-compare', String(representative ? representative.compare || 0 : 0));
        promoIncomplete.setAttribute('data-mg-promo-varies', 'true');
      }
      var mainLabel = form.querySelector('[data-mg-atc-label]');
      var mainButton = $('[data-mg-atc]', form);
      if (mainLabel) mainLabel.textContent = 'CHOOSE A SIZE';
      if (mainButton) { mainButton.disabled = false; mainButton.setAttribute('aria-disabled', 'false'); }
      updateStickyProduct(representative, { incomplete: true, varies: true, price: priceText, variantText: 'Select a size' });
      paintPromoPrices(form);
      form.dispatchEvent(new CustomEvent('mg:variant-change', { bubbles: true, detail: { variant: null } }));
      return;
    }

    var match = null;
    for (var i = 0; i < data.length; i++) {
      var ok = true;
      for (var k in chosen) { if (data[i].options[k] !== chosen[k]) { ok = false; break; } }
      if (ok) { match = data[i]; break; }
    }
    if (!match) return;

    var idInput = $('[data-mg-variant-id]', form);
    if (idInput) idInput.value = match.id;
    updateVariantUrl(match.id);

    $$('[data-mg-price]', form).forEach(function (el) { el.textContent = money(match.price); });
    var promoPrice = form.querySelector('[data-mg-promo-price]');
    if (promoPrice) {
      promoPrice.setAttribute('data-mg-promo-base', String(match.price));
      promoPrice.setAttribute('data-mg-promo-compare', String(match.compare || 0));
      promoPrice.setAttribute('data-mg-promo-varies', 'false');
    }
    $$('[data-mg-compare]', form).forEach(function (el) {
      if (match.compare > match.price) { el.textContent = money(match.compare); el.hidden = false; }
      else { el.hidden = true; }
    });
    updateSavings(form, match.price, match.compare);
    $$('[data-mg-option-label]', form).forEach(function (el) {
      var n = el.getAttribute('data-mg-option-label');
      if (chosen[n] != null) el.textContent = chosen[n];
    });

    var btn = $('[data-mg-atc]', form);
    var lbl = form.querySelector('[data-mg-atc-label]');
    if (lbl) lbl.textContent = match.available ? (lbl.getAttribute('data-prefix') || 'ADD TO CART') : 'SOLD OUT';
    if (btn) { btn.disabled = !match.available; btn.setAttribute('aria-disabled', String(!match.available)); }

    if (match.mediaIndex !== null && match.mediaIndex !== undefined) showMedia($('[data-mg-gallery]'), match.mediaIndex);

    updateStickyProduct(match, { variantText: match.title });
    paintPromoPrices(form);
    form.dispatchEvent(new CustomEvent('mg:variant-change', { bubbles: true, detail: { variant: match } }));
  }

  document.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-mg-option]');
    if (!opt || opt.disabled) return;
    e.preventDefault();
    var name = opt.getAttribute('data-mg-option');
    var form = opt.closest('[data-mg-product-form]');
    Array.prototype.forEach.call(form.querySelectorAll('[data-mg-option="' + name + '"]'), function (b) {
      b.setAttribute('aria-pressed', String(b === opt));
    });
    Array.prototype.forEach.call(form.querySelectorAll('[data-mg-option-label]'), function (el) {
      if (el.getAttribute('data-mg-option-label') === name) el.textContent = opt.getAttribute('data-value');
    });
    pickVariant(form);
    var colorRow = opt.closest('[data-mg-color-limit]');
    if (colorRow) paintColorCollapse(colorRow);
  });

  /* ---- quantity ---- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-mg-qty-step]');
    if (!step) return;
    e.preventDefault();
    var input = $('[data-mg-qty]', step.closest('.mg-qty'));
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-mg-qty-step'), 10));
  });

  /* ---- sticky mobile atc ---- */
  function updateStickyOffset(bar) {
    if (!bar || window.innerWidth > 899) return;
    var offset = 0;
    var candidates = [];
    var seen = [];
    var sampleX = [12, Math.round(window.innerWidth / 2), Math.max(12, window.innerWidth - 12)];
    if (document.elementsFromPoint) {
      sampleX.forEach(function (x) {
        Array.prototype.forEach.call(document.elementsFromPoint(x, Math.max(0, window.innerHeight - 2)), function (hit) {
          var el = hit;
          var depth = 0;
          while (el && el !== document.body && depth < 5) {
            if (seen.indexOf(el) === -1) {
              seen.push(el);
              candidates.push(el);
            }
            el = el.parentElement;
            depth += 1;
          }
        });
      });
    }
    candidates.forEach(function (el) {
      if (el === bar || el.contains(bar) || bar.contains(el) || el.hidden) return;
      if (el.closest('.mg-panel, .mg-scrim, .mg-header, .mg-sticky')) return;
      var style = window.getComputedStyle(el);
      if (style.position !== 'fixed' && style.position !== 'sticky') return;
      if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity || '1') < 0.05) return;
      var rect = el.getBoundingClientRect();
      if (rect.height < 28 || rect.height > 220 || rect.width < 28) return;
      if (rect.bottom < window.innerHeight - 4 || rect.top < window.innerHeight - 240) return;
      offset = Math.max(offset, Math.ceil(window.innerHeight - rect.top));
    });
    bar.style.setProperty('--mg-sticky-offset', Math.min(offset, 220) + 'px');
  }

  function initSticky(scope) {
    var bar = scope.querySelector('.mg-sticky');
    if (!bar || bar.dataset.mgReady === '1') return;
    var anchor = document.querySelector('[data-mg-atc]');
    if (!anchor) return;
    bar.dataset.mgReady = '1';
    var paintSticky = function (entry) {
      var rect = entry ? entry.boundingClientRect : anchor.getBoundingClientRect();
      var visible = entry ? entry.isIntersecting : rect.bottom > 0 && rect.top < window.innerHeight;
      bar.classList.toggle('is-visible', !visible && rect.top < 0);
    };
    new IntersectionObserver(function (entries) { paintSticky(entries[0]); }, { threshold: 0 }).observe(anchor);
    window.addEventListener('pageshow', function () { paintSticky(); });
    var refreshOffset = function () { updateStickyOffset(bar); };
    window.addEventListener('resize', function () { refreshOffset(); paintSticky(); });
    window.addEventListener('orientationchange', refreshOffset);
    [0, 500, 1500, 3000].forEach(function (delay) { window.setTimeout(function () { refreshOffset(); paintSticky(); }, delay); });
  }

  /* ---- size chart units ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mg-unit]');
    if (!b) return;
    e.preventDefault();
    var unit = b.getAttribute('data-mg-unit');
    var modal = b.closest('.mg-panel') || document;
    $$('[data-mg-unit]', modal).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
    $$('[data-in]', modal).forEach(function (cell) {
      var inches = parseFloat(cell.getAttribute('data-in'));
      cell.textContent = unit === 'cm' ? (inches * 2.54).toFixed(1) : String(inches);
    });
    $$('[data-mg-unit-label]', modal).forEach(function (l) { l.textContent = unit === 'cm' ? 'cm' : 'in'; });
  });

  window.MG.pickVariant = pickVariant;
  window.MG.showMedia = showMedia;

  function boot(scope) {
    scope = scope || document;
    sortSwatches(scope);
    initSticky(scope);
    pickVariant(scope.querySelector('[data-mg-product-form]') || document.querySelector('[data-mg-product-form]'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();

